<template>
  <div class="Introduction">
    <div class="container one-container">
      <div class="container-title">
        国内领军数字人应用全链路解决方案服务商
      </div>
      <div class="container-describe">
        1个自研大模型+2个标准化产品+N个场景应用
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog(1)">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg1 two-container" id="nd1Nne2R8QDSsDxB">
      <div class="container-title">关于八点八数字</div>
      <div class="container-describe">让数字人走入千行百业千家万户</div>
      <div class="container-content">
        <div class="content-top">
          八点八数字成立于2014年，十年深耕数字人应用领域。获国家级高新技术企业认证，融资数千万元，获近百项荣誉奖项。拥有数字人领域核心技术发明专利及多项创新成果，国内首推数字人AIGC应用开放平台—XMEN.AI，并推出三款消费级数字人应用:亿话—数字人AIGC实时交互平台、亿影—数字人AIGC视频创作平台、亿展-元宇宙空间AIGC生成平台。实现数字人实时交互、视频快速生成，并提供数字人AIGC一站式全链路解决方案。全面赋能智慧融媒、数字文旅、金融教育、企服展厅等产业，同时是国家电网、中国电信、中国移动、腾讯、360集团、江苏广电、贵州金服、汇丰银行、宝通科技、美团、新华社、南京文投、腾讯烟台新工科研究院等长期战略合作伙伴。
        </div>
        <div class="content-bottom" style="margin-bottom: 2.5rem">
          <div
            class="bottom-item"
            v-for="(item, index) in dataLst[0]"
            :key="index"
          >
            <div class="item-percent">
              {{ item.percent }}
              <div class="item-unit">{{ item.unit }}</div>
            </div>
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
        <div class="content-bottom">
          <div
            class="bottom-item"
            v-for="(item, index) in dataLst[1]"
            :key="index"
          >
            <div class="item-percent">
              {{ item.percent }}
              <div class="item-unit">{{ item.unit }}</div>
            </div>
            <div class="item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container bg3 three-container" id="B7SFAfEH5nE6sapN">
      <div class="container-title">公司大事记</div>
      <div class="container-describe">一步一脚印 精彩里程碑</div>
      <div class="container-content">
        <div class="content-year">{{ memoirList[memoirIndex].year }}年</div>
        <div class="content-ul">
          <ul>
            <li
              v-for="(item, index) in memoirList[memoirIndex].storys"
              :key="index"
              :style="{ opacity: item.opacity }"
            >
              {{ item.text }}
            </li>
          </ul>
        </div>
        <div class="content-time-line">
          <div class="time-line"></div>
          <div class="time-node-box">
            <div
              :class="['time-nodes', memoirIndex == index ? 'selected' : '']"
              v-for="(item, index) in memoirList"
              :key="index"
            >
              <div class="time-node" @click="memoirIndex = index"></div>
              <div class="time-title">{{ item.year }}年</div>
            </div>
          </div>
        </div>
        <div class="content-btn pre" @click="changeMemoirIndex(-1)">
          <img :src="`${$CdnServerAddress}websit/web/arrow.svg`" />
        </div>
        <div class="content-btn next" @click="changeMemoirIndex(1)">
          <img :src="`${$CdnServerAddress}websit/web/arrow.svg`" />
        </div>
      </div>
      <div class="container-btns">
        <div class="btn btn-apply" @click="openApplyDialog(1)">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="container bg2 four-container" id="9cJKdZf2i56B4nnt">
      <div class="container-img"></div>
      <div class="container-content">
        <div class="content-title">开发者平台</div>
        <div class="content-describe">
          共建AI生态，用无尽想象力解放千行百业生产力
        </div>
        <div class="content-platform">
          <div
            class="platform-item"
            v-for="(item, index) in platformList"
            :key="index"
          >
            <div class="item-icon">
              <img :src="item.url" />
            </div>
            <div class="item-title">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="content-btns">
          <div class="btn btn-apply" @click="openApplyDialog(4)">
            立即加入
            <div class="btn-icon"></div>
          </div>
          <div class="btn btn-consult" @click="openApplyDialog(4)">
            了解更多
            <div class="btn-icon"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="container bg1 five-container" id="0WMQpe9Ga1D6B8ss">
      <div class="container-title">资讯动态</div>
      <div class="container-describe">关注最新产品动态、公司新闻及行业动态</div>
      <div class="container-content">
        <div
          class="content-item"
          v-for="(item, index) in newsList"
          :key="index"
          @click="openWebPage(item.link)"
        >
          <div class="item-preview">
            <img :src="item.preivew" />
          </div>
          <div class="item-title">
            {{ item.title }}
          </div>
          <div class="item-content">
            {{ item.content }}
          </div>
          <div class="item-time">
            {{ item.time }}
          </div>
        </div>
      </div>
      <div
        class="container-btns"
        @click="
          openWebPage('https://mp.weixin.qq.com/s/vsOmbRkvAw4wVcy2rLJw4w')
        "
      >
        <div class="btn btn-consult">
          查看更多
          <div class="btn-icon more"></div>
        </div>
      </div>
    </div>

    <div class="container six-container" id="8SF8HYa1tAHaN7C2">
      <div class="container-title">加入我们</div>
      <div class="container-describe">让我们携手并进，共同成长</div>
      <div class="container-content-box">
        <div
          class="container-content"
          :style="[{ transform: `translateX(${translateX}rem)` }]"
        >
          <div
            class="content-item"
            v-for="(item, index) in jobList"
            :key="index"
          >
            <div class="item-name">{{ item.name }}</div>
            <div class="item-label">南京 | 全职 | 社会招聘</div>
            <div class="item-require">任职要求:</div>
            <div class="item-describes">
              <div
                class="describe"
                v-for="(describeItem, describeIndex) in item.describes"
                :key="describeIndex"
              >
                {{ describeItem }}
              </div>
            </div>
            <div class="item-btn" @click="openWebPage(item.link)">
              立即投递
              <div class="btn-icon"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-btns">
        <div class="container-btn pre" @click="changeTranslateX(1)">
          <img :src="`${$CdnServerAddress}websit/web/arrow.svg`" />
        </div>
        <div class="container-btn next" @click="changeTranslateX(-1)">
          <img :src="`${$CdnServerAddress}websit/web/arrow.svg`" />
        </div>
      </div>
    </div>

    <div class="container bg2 seven-container" id="HBhG1ebcN4BxTZA4">
      <div class="container-title">权威资质证书，实力荣誉兼备</div>
      <div class="container-credentials">
        <div
          class="credentials-item"
          v-for="(item, index) in credentialsList"
          :key="index"
        >
          <div class="item-logo">
            <img :src="item.logo" />
          </div>
          <div class="item-names">
            <div
              class="item-name"
              v-for="(nameItem, nameIndex) in item.names"
              :key="nameIndex"
            >
              {{ nameItem }}
            </div>
          </div>
        </div>
      </div>
      <div class="container-title">多项知识产权</div>
      <div class="container-ownership">
        <IntroductionMarquee :list="ownershipList" />
      </div>
    </div>

    <div class="container bg1 eight-container" id="TNAAJKa7i0cPPwwD">
      <div class="container-title">客户案例</div>
      <div class="container-describe">
        以非凡实力成为行业头部客户数字人AIGC应用的不二智选
      </div>
      <IntroductionMarquee :list="marqueeList" style="margin-bottom: 1.25rem" />
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";
import IntroductionMarquee from "@/components/introductionMarquee/index.vue";

export default {
  name: "IntroductionPage",
  components: {
    IntroductionMarquee,
  },
  data() {
    return {
      dataLst: [
        [
          { id: 1, name: "行业沉淀", percent: 10, unit: "年+" },
          { id: 2, name: "行业大奖", percent: 15, unit: "项+" },
          { id: 3, name: "3D数据资产", percent: 10, unit: "万+" },
          { id: 4, name: "AI参数模型", percent: 10, unit: "亿+" },
        ],
        [
          { id: 5, name: "学术论文", percent: 50, unit: "篇+" },
          { id: 6, name: "发明专利", percent: 20, unit: "篇+" },
          { id: 7, name: "硕博人才", percent: 20, unit: "位+" },
          { id: 8, name: "资深研发", percent: 70, unit: "%" },
        ],
      ],
      memoirList: [
        {
          id: 1,
          year: 2020,
          storys: [
            {
              text: "布局超写实虚拟人扫描及特效技术，推出国内首部数字演员网络电影《机械玩家》。",
              opacity: 1,
            },
            {
              text: "布局超写实虚拟人扫描及特效技术，推出国内首部数字演员网络电影《机械玩家》。",
              opacity: 0,
            },
            {
              text: "布局超写实虚拟人扫描及特效技术，推出国内首部数字演员网络电影《机械玩家》。",
              opacity: 0,
            },
          ],
        },
        {
          id: 2,
          year: 2021,
          storys: [
            {
              text: "推出国内首个古风超写实虚拟偶像IP九黎，成为凤凰网首位数字记者。",
              opacity: 1,
            },
            {
              text: "推出国内首个古风超写实虚拟偶像IP九黎，成为凤凰网首位数字记者。",
              opacity: 0,
            },
            {
              text: "推出国内首个古风超写实虚拟偶像IP九黎，成为凤凰网首位数字记者。",
              opacity: 0,
            },
          ],
        },
        {
          id: 3,
          year: 2022,
          storys: [
            { text: "完成千万级首轮融资；", opacity: 1 },
            {
              text: "近百个优秀虚拟人案例落地，荣获中国AI落地商业三十强、中国国际广告节元宇宙整合营销金奖。",
              opacity: 1,
            },
            {
              text: "近百个优秀虚拟人案例落地，荣获中国AI落地商业三十强、中国国际广告节元宇宙整合营销金奖。",
              opacity: 0,
            },
          ],
        },
        {
          id: 4,
          year: 2023,
          storys: [
            {
              text: "完成数千万A+轮融资；发布国内首个双引擎架构、端云协同的AIGC虚拟人元宇宙引擎XMEN.AI；",
              opacity: 1,
            },
            {
              text: "荣获2023第十一届文化产业“金梧桐奖”优秀投资项目；荣获2023数字营销实战大赛-年度数字虚拟人奖；",
              opacity: 1,
            },
            {
              text: "荣获第四届长三角国际文化产业博览“金灯塔奖”数字文创奖；荣获国家高新技术企业认定。",
              opacity: 1,
            },
          ],
        },
        {
          id: 5,
          year: 2024,
          storys: [
            {
              text: "十载风华，数字人综合能力测评第一！荣获近十项数字人核心技术发明专利！",
              opacity: 1,
            },
            {
              text: "与多家头部大厂达成战略合作，打造新华社数字记者小诤、新媒体大会数字人屈原、国家级新区江北新区江小北、上海文广SMG数宇人王子希、苏州广电数字人苏意等多个破圈IP，迎来高速增长！",
              opacity: 1,
            },
          ],
        },
      ],
      memoirIndex: 3,
      platformList: [
        {
          id: 1,
          title: "XMEN API",
          url: `${this.$CdnServerAddress}websit/web/API.png`,
        },
        {
          id: 2,
          title: "Mobile SDK",
          url: `${this.$CdnServerAddress}websit/web/mobile.png`,
        },
        {
          id: 3,
          title: "H5 SDK",
          url: `${this.$CdnServerAddress}websit/web/h5.png`,
        },
        {
          id: 4,
          title: "Windows SDK",
          url: `${this.$CdnServerAddress}websit/web/windows.png`,
        },
      ],
      newsList: [
        {
          id: 1,
          preivew: `${this.$CdnServerAddress}websit/web/newspic1.png`,
          title:
            "数字人李清照走进中国大运河博物馆，赋能“水韵江苏·精彩非遗”展示季！",
          content:
            "在近日于扬州中国大运河博物馆盛大启幕的“水韵江苏·精彩非遗”展示季活动中，科技与文化交融的璀璨火花再次点燃。现场江苏省文化和旅游厅党组书记、厅长杨志纯，省文化和旅游厅党组成员、副厅长钱钢出席活...",
          time: "2024-09-02",
          link: "https://mp.weixin.qq.com/s/E4oCeMQLUa0C87mNu4dykg",
        },
        {
          id: 2,
          preivew: `${this.$CdnServerAddress}websit/web/newspic2.png`,
          title:
            "八点八数字科技驱动AI数字人“亮相”江苏省数字人应用创新大赛八点八数字科技驱动AI数字人... ",
          content:
            "近日，八点八数字CEO耿广星及其研发团队所撰写的论文成功被A类国际学术会议ACM MM（ACM International Conference on Multimedia）2024录用。这一成果不仅彰显了八点八数字在人工智能...",
          time: "2024-08-20",
          link: "https://mp.weixin.qq.com/s/dg962Kb3vJd5UyOaMDU8vw",
        },
        {
          id: 3,
          preivew: `${this.$CdnServerAddress}websit/web/newspic3.png`,
          title:
            "【喜讯】八点八数字科技百位数字员工正式上岗，助力千行百业智能化转型",
          content:
            "近日八点八数字科技迎来了新的里程碑——百位数字员工正式上岗。这是公司在数字人形象专业设计领域的一次创新突破，为企业智能化转型注入新活力。这些数字员工，以其独特的风格、行业背景和文化特色，积极响...",
          time: "2024-06-06",
          link: "https://mp.weixin.qq.com/s/LE-DvB8vBRhZfSvp-rfv3A",
        },
      ],
      jobList: [
        {
          id: 1,
          name: "人工智能算法",
          describes: [
            "1、熟练掌握python语言，能够编写数据库语言。",
            "2、对NLP的基础知识掌握熟练，有扎实的基本功,能够阅读英文文献,具备英文沟通能力。",
            "3、了解transformer、知识图谱相关知识,有过KBQA系统工作经验,在AI领域发表过论文。",
          ],
          link: "https://www.zhipin.com/job_detail/9cb9f69b8897b8c703Rz2929ElFR.html?ka=company_more_job_9cb9f69b8897b8c703Rz2929ElFR",
        },
        {
          id: 2,
          name: "角色模型",
          describes: [
            "1、熟练使用Maya、Zbrush、Photoshop、SubstancePainter等常用软件。",
            "2、至少3年以上角色向游戏美术或CG制作经验。",
            "3、有UE5使用经验优先。",
          ],
          link: "https://www.zhipin.com/job_detail/499f33b91a1f07ae1HN739W_ElFS.html?ka=company_more_job_499f33b91a1f07ae1HN739W_ElFS",
        },
        {
          id: 3,
          name: "场景模型",
          describes: [
            "1、熟练使用Maya、Zbrush、Photoshop、SubstancePainter等常用软件。",
            "2、至少3年以上角色向游戏美术或CG制作经验。",
            "3、有UE5使用经验优先。",
          ],
          link: "https://www.zhipin.com/job_detail/54bd84a78ab882251Hx7396-GFJW.html?ka=company_more_job_54bd84a78ab882251Hx7396-GFJW",
        },
      ],
      translateX: 0,
      credentialsList: [
        {
          id: 1,
          logo: `${this.$CdnServerAddress}websit/web/certificate1.png`,
          names: ["网络安全等级", "保护2.0(三级)"],
        },
        {
          id: 2,
          logo: `${this.$CdnServerAddress}websit/web/certificate2.png`,
          names: ["国家高新", "技术企业"],
        },
        {
          id: 3,
          logo: `${this.$CdnServerAddress}websit/web/certificate3.png`,
          names: ["ISO9001质量", "体系证书"],
        },
        {
          id: 4,
          logo: `${this.$CdnServerAddress}websit/web/certificate4.png`,
          names: ["3A级企业信用", "等级证书"],
        },
        {
          id: 5,
          logo: `${this.$CdnServerAddress}websit/web/certificate5.png`,
          names: ["ISO27001信息安全", "管理体系证书"],
        },
        {
          id: 6,
          logo: `${this.$CdnServerAddress}websit/web/certificate6.png`,
          names: ["软件著作权", "证书"],
        },
      ],
      ownershipList: [
        { url: `${this.$CdnServerAddress}websit/web/award1.png`, width: 339 },
        { url: `${this.$CdnServerAddress}websit/web/award2.png`, width: 170 },
        { url: `${this.$CdnServerAddress}websit/web/award3.png`, width: 170 },
        { url: `${this.$CdnServerAddress}websit/web/award4.png`, width: 170 },
        { url: `${this.$CdnServerAddress}websit/web/award5.png`, width: 170 },
        { url: `${this.$CdnServerAddress}websit/web/award6.png`, width: 170 },
        { url: `${this.$CdnServerAddress}websit/web/award7.png`, width: 178 },
        { url: `${this.$CdnServerAddress}websit/web/award8.png`, width: 178 },
        { url: `${this.$CdnServerAddress}websit/web/award9.png`, width: 178 },
        { url: `${this.$CdnServerAddress}websit/web/award10.png`, width: 178 },
        { url: `${this.$CdnServerAddress}websit/web/award11.png`, width: 178 },
        { url: `${this.$CdnServerAddress}websit/web/award12.png`, width: 178 },
      ],
      marqueeList: [
        {
          url: `${this.$CdnServerAddress}websit/web/casepic1.png`,
          width: 388.5,
          name: "新华社数字记者小诤",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic2.png`,
          width: 388.5,
          name: "新媒体大会数字人屈原",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic3.png`,
          width: 388.5,
          name: "凤凰网数字人九黎 ",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic4.png`,
          width: 388.5,
          name: "上海文广SMG数字人壬子希",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic5.png`,
          width: 388.5,
          name: "苏州广电数字人苏意",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic6.png`,
          width: 388.5,
          name: "江北新区数字人江小北 ",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic7.png`,
          width: 388.5,
          name: "南京非遗馆数字人朱元璋 ",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic8.png`,
          width: 388.5,
          name: "山西文旅数字人青鸟",
        },
        {
          url: `${this.$CdnServerAddress}websit/web/casepic9.png`,
          width: 388.5,
          name: "山西祁县数字人王维",
        },
      ],
    };
  },
  mounted() {
    if (location.hash) {
      let id = location.hash.replace("#", "");
      document.getElementById(id).scrollIntoView();
      let y = window.scrollY;
      window.scrollTo(0, y - 64);
    }
  },
  methods: {
    openApplyDialog(type) {
      EventBus.$emit("openApplyDialog", { type: type });
    },
    openContactDialog() {
      EventBus.$emit("openContactDialog");
    },
    changeMemoirIndex(step) {
      let index = this.memoirIndex + step;
      if (index < 0) {
        index = this.memoirList.length - 1;
      }
      if (index >= this.memoirList.length) {
        index = 0;
      }
      this.memoirIndex = index;
    },
    changeTranslateX(step) {
      let width = (36 * window.innerWidth) / 100 + 50;

      let result = this.translateX + step * width;
      if (step > 0 && result > 0) {
        result = 0;
      }
      if (step < 0 && result < step * (this.jobList.length - 2) * width) {
        result = step * (this.jobList.length - 2) * width;
      }
      this.translateX = result / 16;
    },
    openWebPage(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.Introduction {
  width: 100%;
  position: relative;
  color: #ffffff;
  background: #000000;

  .container {
    width: 100%;
    min-height: calc(~"100vh - 64px");
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;

    &.one-container {
      margin-top: 64px;
      background: url("https://bdbcdn.bdbdigital.com/websit/web/mine_banner.png")
        center no-repeat #000000;
      background-size: cover;
      position: relative;

      .container-describe {
        color: #ffffff;
        margin-bottom: 100px;
      }
    }

    &.two-container {
      .container-content {
        width: 72%;
        margin-bottom: 20px;

        .content-top {
          font-size: 24px;
          color: #bfbfbf;
          line-height: 36px;
          margin-bottom: 60px;
        }

        .content-bottom {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .bottom-item {
            width: 136.2px;
            height: 138px;

            .item-percent {
              background-image: -webkit-linear-gradient(
                90deg,
                #a6000d 0%,
                #b71a20 50%,
                #4f0023 100%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              margin-bottom: 24px;
              display: flex;
              align-items: baseline;
              justify-content: center;
              font-size: 64px;
              font-weight: bold;

              .item-unit {
                font-size: 30px;
                font-weight: normal;
                margin-left: 5px;
              }
            }

            .item-name {
              text-align: center;
              color: #bfbfbf;
            }
          }
        }
      }
    }

    &.three-container {
      .container-content {
        width: 73%;
        color: #bfbfbf;
        margin-bottom: 100px;
        position: relative;

        .content-year {
          background-image: -webkit-linear-gradient(
            90deg,
            #a6000d 0%,
            #b71a20 50%,
            #4f0023 100%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          font-size: 64px;
          font-weight: bold;
          margin-bottom: 40px;
        }

        .content-ul {
          margin-bottom: 60px;

          ul {
            height: 10rem;

            li {
              font-size: 24px;
              margin-bottom: 8px;
            }
          }
        }

        .content-time-line {
          position: relative;

          .time-line {
            width: 100%;
            height: 2px;
            background: linear-gradient(
              90deg,
              rgba(140, 140, 140, 0.2) 0%,
              #8c8c8c 50%,
              rgba(140, 140, 140, 0.2) 100%
            );
            position: absolute;
            top: 15px;
            left: 0;
          }

          .time-node-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 30px;
            padding: 0 42px;

            .time-nodes {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              position: relative;

              &.selected {
                .time-node {
                  background: url("https://bdbcdn.bdbdigital.com/websit/web/dot_red.svg")
                    no-repeat;
                  background-size: 100% 100%;
                }

                .time-title {
                  color: #a6000d;
                }
              }

              .time-node {
                width: 32px;
                height: 32px;
                background: url("https://bdbcdn.bdbdigital.com/websit/web/dot.svg")
                  no-repeat;
                background-size: 100% 100%;
                margin-bottom: 24px;
                cursor: pointer;
              }
            }
          }
        }

        .content-btn {
          width: 38px;
          height: 38px;
          border: 1px solid #bfbfbf;
          border-radius: 50%;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;

          &.pre {
            top: 50%;
            left: -5%;
            transform: translate(0, -50%) rotate(180deg);
          }

          &.next {
            top: 50%;
            right: -5%;
            transform: translate(0, -50%);
          }

          img {
            margin-left: 20%;
          }

          &:hover {
            background: #a6000d;
            border-color: #a6000d;
          }
        }
      }
    }

    &.four-container {
      .container-img {
        background: url("https://bdbcdn.bdbdigital.com/websit/web/openplatform.png")
          center no-repeat;
        background-size: cover;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }

      .container-content {
        position: absolute;
        top: 50%;
        left: 20%;
        transform: translate(0, -50%);

        .content-title {
          font-size: 64px;
          font-weight: bold;
          margin-bottom: 40px;
        }

        .content-describe {
          font-size: 24px;
          margin-bottom: 40px;
          color: #bfbfbf;
        }

        .content-platform {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 100px;

          .platform-item {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 40px;
            border-right: 2px solid #bfbfbf;

            &:first-child {
              padding-left: 0;
            }

            &:last-child {
              border-right: none;
              padding-right: 0;
            }

            .item-icon {
              width: 32px;
              margin-right: 16px;

              img {
                width: 100%;
              }
            }
          }
        }

        .content-btns {
          width: 320px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .btn {
            width: 134px;
            line-height: 38px;
            border: 1px solid #ffffff99;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &:hover {
              background: #ffffff1a;
            }

            &.btn-apply {
              background: #a6000d;
              border-color: #a6000d;

              &:hover {
                background: #80000f;
                border-color: #80000f;
              }
            }

            .btn-icon {
              width: 16px;
              height: 16px;
              background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

    &.five-container {
      .container-content {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 80px;

        .content-item {
          width: 21%;
          padding: 24px;
          border: 1px solid #ffffff33;
          border-radius: 8px;
          margin-right: 40px;
          cursor: pointer;
          transition: margin-bottom 0.1s;
          margin-top: 20px;

          &:hover {
            border-color: #a6000d;
            margin-top: 0;
          }

          &:last-child {
            margin-right: 0;
          }

          .item-preview {
            width: 100%;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 16px;

            img {
              width: 100%;
            }
          }

          .item-title {
            font-size: 18px;
            margin-bottom: 16px;
          }

          .item-content {
            color: #bfbfbf;
            margin-bottom: 16px;
          }

          .item-time {
            color: #bfbfbf;
          }
        }
      }

      .container-btns {
        width: auto;

        .btn-consult {
          width: 144px;

          .more {
            background: url("https://bdbcdn.bdbdigital.com/websit/web/more1.svg")
              no-repeat;
            background-size: 100% 100%;
            margin-left: 8px;
          }
        }
      }
    }

    &.six-container {
      .container-describe {
        margin-bottom: 80px;
      }

      .container-content-box {
        width: calc(~"72vw + 50px");
        overflow: hidden;
        margin-bottom: 80px;
        display: flex;

        .container-content {
          white-space: nowrap;
          display: flex;
          transition: transform 0.4s;

          .content-item {
            width: calc(~"36vw - 48px");
            background: url("https://bdbcdn.bdbdigital.com/websit/web/job-bg.png")
              right no-repeat #242424;
            background-size: auto 100%;
            border-radius: 8px;
            padding: 24px;
            margin-right: 50px;

            &:last-child {
              margin-right: 0;
            }

            .item-name {
              font-size: 30px;
              margin-bottom: 24px;
            }

            .item-label {
              color: #bfbfbf;
              margin-bottom: 24px;
            }

            .item-require {
              font-size: 18px;
              color: #bfbfbf;
              margin-bottom: 24px;
            }

            .item-describes {
              width: 100%;
              color: #bfbfbf;
              margin-bottom: 40px;
              overflow: auto;

              .describe {
                margin-bottom: 8px;

                &:last-child {
                  margin-bottom: 0;
                }
              }
            }

            .item-btn {
              width: 144px;
              line-height: 38px;
              border: 1px solid #ffffff99;
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;

              &:hover {
                background: #a6000d;
                border-color: #a6000d;
              }

              .btn-icon {
                width: 16px;
                height: 16px;
                background: url("https://bdbcdn.bdbdigital.com/websit/web/more1.svg")
                  no-repeat;
                background-size: 100% 100%;
                margin-left: 8px;
              }
            }
          }
        }
      }

      .container-btns {
        display: flex;
        align-items: center;
        justify-content: center;

        .container-btn {
          width: 38px;
          height: 38px;
          border: 1px solid #bfbfbf;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          cursor: pointer;

          &.pre {
            transform: rotate(180deg);
            margin-right: 50px;
          }

          &.next {
          }

          img {
            margin-left: 20%;
          }

          &:hover {
            background: #a6000d;
            border-color: #a6000d;
          }
        }
      }
    }

    &.seven-container {
      .container-credentials {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 40px;

        .credentials-item {
          margin-right: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          &:last-child {
            margin-right: 0;
          }

          .item-logo {
            width: 160px;
            margin-bottom: 40px;

            img {
              width: 100%;
            }
          }

          .item-names {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;

            .item-name {
              font-size: 24px;
              color: #bfbfbf;
              line-height: 32px;
            }
          }
        }
      }

      .container-ownership {
        width: 100%;
        overflow: hidden;
      }
    }

    &.eight-container {
      width: 100%;
      overflow: hidden;

      .container-describe {
        margin-bottom: 80px;
      }
    }

    &.bg1 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg1.png") center
        no-repeat #000000;
      background-size: cover;
    }

    &.bg2 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg2.png") center
        no-repeat #000000;
      background-size: cover;
    }

    &.bg3 {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bg3.png") center
        no-repeat #000000;
      background-size: cover;
    }

    .container-title {
      max-width: 74%;
      font-size: 64px;
      font-weight: bold;
      margin-bottom: 40px;
    }

    .container-describe {
      font-size: 24px;
      margin-bottom: 40px;
      color: #bfbfbf;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .container-btns {
      width: 320px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;

      .btn {
        width: 134px;
        line-height: 38px;
        border: 1px solid #ffffff99;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #ffffff1a;
        }

        &.btn-apply {
          background: #a6000d;
          border-color: #a6000d;

          &:hover {
            background: #80000f;
            border-color: #80000f;
          }
        }

        .btn-icon {
          width: 16px;
          height: 16px;
          background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>